var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 561 612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-1",
    d: "M275.4,295.8A147.9,147.9,0,1,0,127.5,147.9,147.9,147.9,0,0,0,275.4,295.8Zm70.061-89.2c-6.729,22.246-35.549,38.968-70.09,38.968S212.008,228.849,205.28,206.6ZM586.5,510v20.4a10.2,10.2,0,0,1-10.2,10.2H515.1v61.2A10.2,10.2,0,0,1,504.9,612H484.5a10.2,10.2,0,0,1-10.2-10.2V540.6H413.1a10.2,10.2,0,0,1-10.2-10.2V510a10.2,10.2,0,0,1,10.2-10.2h61.2V438.6a10.2,10.2,0,0,1,10.2-10.2h20.4a10.2,10.2,0,0,1,10.2,10.2v61.2h61.2A10.2,10.2,0,0,1,586.5,510Zm-204,0v20.4a30.218,30.218,0,0,0,4.016,14.857c-30.8,3.35-67.52,5.542-111.116,5.542-142.607,0-212.393-23.3-237.979-34.686-6.6-2.938-11.921-11.336-11.921-18.562V448.8c0-73.056,55.624-133.663,126.6-141.78a11.84,11.84,0,0,1,7.113,1.949,197.336,197.336,0,0,0,232.376,0,11.841,11.841,0,0,1,7.113-1.949c58.746,6.719,106.869,49.438,121.744,105.37A30.253,30.253,0,0,0,504.9,408H484.5a30.634,30.634,0,0,0-30.6,30.6v40.8H413.1A30.632,30.632,0,0,0,382.5,510Z",
    transform: "translate(-25.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebCheckin);
export default __webpack_public_path__ + "static/media/web-checkin.a3857ab20d17d2ccf6ca1e8f260080df.svg";
export { ForwardRef as ReactComponent };